<template>
  <!-- 创建,编辑信息 -->
  <div>
    <table class="simpleRow" >
      <tr>
        <td width='10%' align='left'>
          <span class="simpleLabel">{{$t('message.创建者')}}</span>
        </td>
        <td width='35%'>
          <el-input
            clearable
            v-model="serverData[0].name"
            size="small"
            :disabled="true"
          />
        </td>
        <td width='5%'></td>
        <td width='10%' align='left'>
          <span class="simpleLabel">{{$t('message.创建时间')}}</span>
        </td>
        <td width='40%'>
          <el-input
            clearable
            v-model="createdate"
            size="small"
            :disabled="true"
          />
        </td>
      </tr>
    </table>
    <table class="simpleRow" >
      <tr>
        <td width='10%' align='left'>
          <span class="simpleLabel">{{$t('message.编辑者')}}</span>
        </td>
        <td width='35%'>
          <el-input clearable v-model="serverData[1].name" size="small" :disabled="true" />
        </td>
        <td width='5%'></td>
        <td width='10%' align='left'>
          <span class="simpleLabel">{{$t('message.编辑时间')}}</span>
        </td>
        <td width='40%' >
          <el-input
            clearable
            v-model="editdate"
            size="small"
            :disabled="true"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "EditInfo",

  props: {
    createdate: "",
    editdate: "",
  },

  data() {
    return {
      appid: 188,
      serverData:[
        {name:""},
        {name:""},
      ],//[0]创建者 [1]编辑者
    };
  },

  methods: {
    getServerData(serverData){
      this.serverData = serverData;
    },
  },

  watch: {
    createdate: {
      handler(val, oldVal) {},
      deep: true,
      immediate: true,
    },
    editdate: {
      handler(val, oldVal) {},
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Organization/EditInfo.vue